import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-heading font-bold text-background-50">
                禁漫天堂
              </span>
            </div>
            <p className="text-foreground-300 text-sm leading-relaxed">
              禁漫天堂是广受用户关注的漫画阅读平台，提供丰富的漫画资源和优质的阅读体验。本网站为官方使用指南与入口导航页。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-foreground-300 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/categories" className="text-foreground-300 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  内容分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-300 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold mb-4">热门教程</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/article/latest-access-2026" className="text-foreground-300 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  最新访问入口
                </Link>
              </li>
              <li>
                <Link to="/article/register-login-guide" className="text-foreground-300 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  注册登录教程
                </Link>
              </li>
              <li>
                <Link to="/article/content-category-overview" className="text-foreground-300 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  内容分类导览
                </Link>
              </li>
              <li>
                <Link to="/article/mirror-site-guide" className="text-foreground-300 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  镜像站指南
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold mb-4">联系方式</h4>
            <ul className="space-y-2.5 text-foreground-300 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>support@jmtt.example.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-global-line"></i>
                <span>jmtt.example.com</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:text-background-50 hover:bg-primary-600 transition-all cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:text-background-50 hover:bg-primary-600 transition-all cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:text-background-50 hover:bg-primary-600 transition-all cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-400 text-xs">
            &copy; 2026 禁漫天堂使用指南. 本站为独立导航与教程站点，非官方直营网站。
          </p>
          <div className="flex items-center gap-4 text-foreground-400 text-xs">
            <a href="#" className="hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">使用条款</a>
            <a href="#" className="hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}